module.exports = __webpack_public_path__ + "files/819613a0985df0a504463029490791a5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-4.png
// module id = 1493
// module chunks = 60